import React from 'react';

const ChangeLogPopUpSkeleton = () => {
  const skeletonItems = Array.from({ length: 4 }, (_, idx) => ({ id: `skeleton-${idx}` }));
  return (
    <div className="px-5 py-3 space-y-4">
      {skeletonItems.map((item) => (
        <div key={item.id}>
          <div className="flex items-center animate-pulse">
            <span className="h-6 w-12 rounded bg-slate-700 mr-2" />
            <div className="flex-1 h-6 rounded bg-slate-700" />
          </div>
          <div className="h-4 w-20 rounded bg-slate-800 mt-2" />
        </div>
      ))}
    </div>
  );
};

export default ChangeLogPopUpSkeleton;
